// Хелперы для текстов из RichEditor админки (хранятся как HTML). Старый контент
// — простой текст с переносами; toHtml поднимает его до абзацев, чтобы переход
// на HTML-рендер не схлопнул старые новости/темы в сплошную простыню.

const HTML_RE = /<[a-z!][\s\S]*>/i;

function escapeHtml(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

/** Простой текст → HTML-абзацы; уже-HTML отдаём как есть. */
export function toHtml(s?: string): string {
  const v = (s || "").trim();
  if (!v) return "";
  if (HTML_RE.test(v)) return v;
  return v
    .split(/\n{2,}/)
    .map((p) => `<p>${escapeHtml(p.trim()).replace(/\n/g, "<br>")}</p>`)
    .join("");
}

/** HTML → плоский текст (для meta-описаний и тизеров-карточек). */
export function stripHtml(s?: string): string {
  return (s || "").replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
}
